import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconApps } from "@tabler/icons-react"
import BaseListItem from "../base"

export interface AppListItemProps {
  item: Record<string, any>
  className?: string
  /** Custom footer content to replace the default "Added by..." text */
  footer?: React.ReactNode
}

export const AppListItem: React.FC<AppListItemProps> = ({ item, className, footer }) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconApps}
    typeLabel="App"
    testId="app-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.USE }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <a href={item.path}>
          <img loading="lazy"
            src={item.thumbnailUrl || item.imageUrl}
            alt={item.name}
            className="max-w-[100px] rounded-xl"
          />
        </a>
      )
    }
  />
)

export default AppListItem
